import { styles } from 'consts';
import styled, { css } from 'styled-components';
import stopHandIcon from '../../assets/images/stop_hand_icon.svg';

const { white, bluePrimary, boxShadow } = styles;

export const TopPaymentInsideNotificationContainer = styled.div`
  font-size: 0.75rem;
  width: 100%;
  background-color: ${bluePrimary};
  box-shadow: 0 0.125rem 0.5rem 0 ${boxShadow};
  justify-content: left;
  box-sizing: border-box;
  border-radius: 0.5rem;
  padding: 0.4rem;
  display: flex;
  flex-direction: row;
  margin: auto;
  align-items: center;

  p {
    color: ${white};
    margin: 0.2rem;
    text-align: left;
  }
`;

export const TopPaymentNotificationContainer = styled.div<{ isVisible: boolean }>`
  text-align: center;
  @media (min-width: 768px) {
    display: none;
  }
  ${props =>
    props.isVisible &&
    css`
      margin: 0 0 0.5rem 0;
    `}
`;

export const Icon = styled.img.attrs({
  alt: 'Stop-hand-icon',
  src: stopHandIcon,
})`
  margin: 0.5rem;
`;
